import {RouteConfig} from 'vue-router';
import ProfileConfigPage from '@/views/profile/ProfileConfigPage.vue';
import ProfilePage from '@/views/profile/ProfilePage.vue';
import ProfileAbout from '@/components/Profile/ProfileAbout.vue';
import ProfileFollowing from '@/components/Profile/ProfileFollowing.vue';
import ProfileActivities from '@/components/Profile/activity/ProfileActivities.vue';
import ProfileTeams from '@/components/Profile/ProfileTeams.vue';
import ProfileAchievements from '@/components/Profile/ProfileAchievements.vue';
import MyChallenges from '@/components/Profile/MyChallenges.vue';
import ProfileInvitations from '@/components/Profile/ProfileInvitations.vue';
import {authenticated} from '@/guards/auth.guard';


export const profileRoutes: RouteConfig[] = [
  {
    path: 'config',
    name: 'profileConfig',
    component: ProfileConfigPage,
    beforeEnter: (to, from, next) => {
      if (authenticated()) {
        next()
      } else {
        next(from.path)
      }
    }
  },
  {
    path: ':slug',
    component: ProfilePage,
    beforeEnter: (to, from, next) => {
      if (to.params.slug === 'me') {
        if (authenticated()) {
          next()
        } else {
          next(from.path)
        }
      } else {
        next()
      }
    },
    children: [
      {
        path: '',
        name: 'ProfileAbout',
        component: ProfileAbout,
      },
      {
        path: 'following',
        name: 'ProfileFollowing',
        component: ProfileFollowing,
      },
      {
        path: 'activities',
        name: 'ProfileActivities',
        component: ProfileActivities,
      },
      {
        path: 'teams',
        name: 'ProfileTeams',
        component: ProfileTeams,
      },
      {
        path: 'challenges',
        name: 'ProfileChallenges',
        component: MyChallenges
      },
      {
        path: 'achievements',
        name: 'ProfileAchievements',
        component: ProfileAchievements,
      },
      {
        path: 'team-invitations',
        name: 'ProfileInvitations',
        component: ProfileInvitations,
        beforeEnter: (to, from, next) => {
          if (authenticated()) {
            next()
          } else {
            next(from.path)
          }
        },
      }
    ],
  },
];
